import React from 'react';
import AdminSideMenu from './AdminSideMenu';
import DynamicSideMenu from './DynamicSideMenu';
import QlikSelectionsMenu from 'components/common/Qlik/QlikSelectionsMenu';
import Delayed from 'components/common/Delayed';

const SidebarMenu = () => {
    return (
        <div className="c-sidebar__body" style={{ paddingBottom: '10vh' }}>
            <div className="c-sidebar__title">Dashboards</div>
            <DynamicSideMenu />

            <Delayed waitBeforeShow={3000}>
                <QlikSelectionsMenu />
            </Delayed>

            <AdminSideMenu />
        </div>
    );
};

SidebarMenu.propTypes = {};

export default SidebarMenu;
